<template>
  <div>
    <template v-if="emailVerificationStatus && emailVerificationStatus.is_invalid">
      <v-alert type="error"
               flat
               tile
               class="mt-2 mb-0">
        <div>
          <strong>Invalid Email: {{ email }}</strong>
        </div>
        <div class="mt-1">
          This email address appears to be undeliverable and will bounce if sent. Please:
          <ul class="mt-1 mb-0">
            <li>
              Check for typos in the address
            </li>
            <li>
              Verify the domain is correct
            </li>
            <li>
              Try an alternative email for this contact
            </li>
          </ul>
          <div>
            You can still add other recipients to your message.
          </div>
        </div>
      </v-alert>
    </template>
    <template v-else-if="didLastMessageBounce">
      <v-alert type="error"
               flat
               tile
               class="mt-2 mb-0">
        <div>
          <strong>Previously Bounced Email: {{ email }}</strong>
        </div>
        <div class="mt-1">
          This address returned a permanent delivery failure when you previously emailed it. To protect your sender reputation:
          <ul class="mt-1 mb-0">
            <li>Use an alternative email for this contact</li>
            <li>Verify with the recipient if their email has changed</li>
          </ul>
          <div>
            You can still add other recipients to your message.
          </div>
        </div>
      </v-alert>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    email: {
      type: String,
      required: false,
    },
    emailVerificationStatus: {
      type: Object,
      required: false,
    },
    didLastMessageBounce: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>
